module.exports = require('./toPairs');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entries.js
// module id = 743
// module chunks = 0